import { Box, Container, Typography, Button, IconButton, Collapse, alpha } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useCurrency } from '../../contexts/CurrencyContext';

export function CurrencyBanner() {
    const { showBanner, setShowBanner, setCurrency, suggestedCurrency } = useCurrency();

    const handleSwitch = () => {
        if (suggestedCurrency) {
            setCurrency(suggestedCurrency);
        }
        setShowBanner(false);
    };

    const handleDismiss = () => {
        setShowBanner(false);
    };

    if (!suggestedCurrency) return null;

    const currencyLabel = {
        'USD': { label: 'US', symbol: '$' },
        'EUR': { label: 'Europe', symbol: '€' },
        'AUD': { label: 'Australia', symbol: '$' },
        'INR': { label: 'India', symbol: '₹' },
        'GBP': { label: 'UK', symbol: '£' }, // Fallback
    }[suggestedCurrency];

    return (
        <Collapse in={showBanner}>
            <Box sx={{
                bgcolor: (theme) => alpha(theme.palette.primary.main, 0.08),
                color: 'text.primary',
                py: 1,
                borderBottom: '1px solid',
                borderColor: 'divider'
            }}>
                <Container maxWidth="lg" sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 2 }}>
                    <Typography variant="body2" fontWeight={500} sx={{ fontSize: '0.85rem' }}>
                        Visiting from {currencyLabel.label}?
                    </Typography>
                    <Button
                        size="small"
                        variant="outlined"
                        onClick={handleSwitch}
                        sx={{
                            fontSize: '0.75rem',
                            py: 0.25,
                            minWidth: 0,
                            height: 24,
                            textTransform: 'none',
                        }}
                    >
                        Switch to {suggestedCurrency} ({currencyLabel.symbol})
                    </Button>
                    <IconButton size="small" onClick={handleDismiss} sx={{ ml: 1, p: 0.25 }}>
                        <CloseIcon fontSize="small" sx={{ fontSize: '1rem', opacity: 0.6 }} />
                    </IconButton>
                </Container>
            </Box>
        </Collapse>
    );
}
